//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    /**
     * Area page: diet | sex-drive | stress | energy | sleep | quiz-diet | quiz-sex-drive | quiz-stress | quiz-energy | quiz-sleep | base-complete-results | base-complete-improvement-plan | how-it-works
     */
    area: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: ''
    }
  },
  computed: {
    faqs () {
      return this.$t(`general.faqs.${this.area}`)
    }
  },
  methods: {
    trackFAQClicked (faq) {
      this.trackGAEvent({ action: 'FAQ clicked' })
      this.addDDAction('FAQ clicked', {
        faq,
        path: this.$route.path
      })
    }
  }
}
